var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M558 1220 c-182 -33 -329 -130 -417 -276 -92 -151 -111 -328 -53 -499 54 -159 212 -314 367 -361 175 -52 339 -34 483 53 279 169 371 528 205 801 -61 100 -144 177 -249 230 -87 44 -245 69 -336 52z m197 -115 c172 -45 305 -179 350 -352 65 -249 -94 -511 -350 -578 -251 -65 -513 94 -580 350 -89 343 237 669 580 580z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442 838 c-27 -27 -13 -62 55 -130 l67 -68 -65 -67 c-76 -78 -83 -92 -63 -122 28 -39 62 -27 136 46 l68 67 68 -67 c71 -70 97 -80 125 -49 29 31 19 54 -50 124 l-67 68 67 68 c68 68 82 103 55 130 -27 27 -62 13 -130 -55 l-68 -67 -68 67 c-68 68 -103 82 -130 55z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCross);
export default __webpack_public_path__ + "static/media/circle-cross.56ac9180a9f034796f062c77c92544ca.svg";
export { ForwardRef as ReactComponent };